import React from "react";
import { FAQ } from "../../mock/mock";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

export default function FAQSection() {
  return (
    <section id="faq" className="bg-[#f3ead9]">
      <div className="max-w-4xl mx-auto px-4 lg:px-8 py-16 md:py-24">
        <div className="text-center">
          <p className="eyebrow text-lg">Questions</p>
          <div className="mx-auto mt-3 ornament-line" />
          <h2 className="mt-4 font-serif-display text-3xl md:text-5xl leading-tight text-[#1a1a1a]">
            Before you apply
          </h2>
        </div>

        <Accordion type="single" collapsible className="mt-10 space-y-3">
          {FAQ.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border border-[#e2d5bb] rounded-xl bg-white px-5">
              <AccordionTrigger className="text-left font-serif-display text-lg md:text-xl text-[#1a1a1a] hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[15px] text-[#1a1a1a]/75 leading-relaxed">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
